




















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    filters: {
        maxCharacter(value: string) {
            return value.slice(0, 80);
        }
    },
    computed: {
        logoColor() {
            const hue =
                "hsl(" +
                360 * Math.random() +
                "," +
                (25 + 70 * Math.random()) +
                "%," +
                (85 + 10 * Math.random()) +
                "%)";
            return { background: `${hue}` };
        },
        logoInitials() {
            let initials = "";
            const nameArr = this.$props.name.split(" ");
            for (const name of nameArr) {
                initials += name.substring(0, 1);
            }
            return initials;
        },
        hasAttendeeProfilePage() {
            return this.$store.getters.layoutOptions.hasAttendeeProfilePage;
        }
    }
})
export default class AttendeeCard extends Vue {
    @Prop({ default: "row" })
    layout!: string;

    @Prop({ default: "" })
    name!: string;

    @Prop({ default: "FL" })
    nameInitial!: string;

    @Prop({ default: "" })
    title!: string;

    @Prop({ default: "" })
    companyName!: string;

    // @Prop({default: {}})
    // company!: object

    @Prop({ default: "" })
    imgPath!: string;

    @Prop({ default: "" })
    phone!: string;

    @Prop({ default: "" })
    email!: string;

    @Prop({ default: "" })
    location!: string;

    @Prop({ default: false })
    hasFullDetail!: boolean;

    @Prop({ default: false })
    isSizeLarge!: boolean;

    @Prop({ default: "" })
    id!: string;

    @Prop({ default: "" })
    accessor!: string;

    routeToDetails() {
        if (this.accessor != "") {
            //accessing outside attendee
            this.$router.push(`/attendees/attendee-profile/${this.id}`);
        } else {
            this.$router.push({
                name: "attendeeProfile",
                params: { id: this.id }
            });
        }
    }

    getFullPath() {
        const isDemoData = !this.$store.getters.awsConfig.attendeeTable;
        if (isDemoData)
            return `https://vmpstore.s3.amazonaws.com/images/attendees/${this.imgPath}`;
        else
            return this.imgPath
                ? this.imgPath
                : require("../../assets/avatar2.png");
    }

    openMessage() {
        this.$router.push({
            name: "Message-Center",
            params: {
                id: this.$props.id,
                name: this.$props.name,
                companyName: this.$props.companyName
            }
        });
    }
}
